var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getRequest, postRequest, putRequest, deleteRequest, RequestDataType, getImageRequest, getFileRequest } from 'services/api';
export var getAllCustomers = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, getRequest("/customers")];
        case 1: return [2 /*return*/, ((_a.sent()) || [])];
    }
}); }); };
export var getSitesForCustomer = function (customerId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, getRequest("/customers/".concat(customerId, "/sites"))];
        case 1: return [2 /*return*/, ((_a.sent()) || [])];
    }
}); }); };
/** Customers */
export var postNewCustomer = function (data) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, postRequest("/customers", data, RequestDataType.Entity)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
export var editCustomer = function (data) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, putRequest("/customers", data, RequestDataType.Entity)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
export var deleteCustomer = function (customerId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, deleteRequest("/customers", customerId)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
/** Sites */
export var postNewSite = function (data) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, postRequest("/sites", data, RequestDataType.FormData)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
export var editSite = function (data) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, putRequest("/sites", data, RequestDataType.FormData)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
export var deleteSite = function (siteId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, deleteRequest("/sites", siteId)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
/** Assets */
export var postNewAsset = function (data) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, postRequest("/assets", data, RequestDataType.FormData)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
export var editAsset = function (data) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, putRequest("/assets", data, RequestDataType.FormData)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
export var deleteAsset = function (assetId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, deleteRequest("/assets", assetId)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
export var getAssetImage = function (assetId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, getImageRequest("/assets/".concat(assetId))];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
export var getAsset3DFile = function (assetId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, getFileRequest("/assets/Get3DFile".concat(assetId))];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
/** Asset Section */
export var postNewAssetSection = function (data) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, postRequest("/assetSections", data, RequestDataType.FormData)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
export var deleteAssetSection = function (assetSectionId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, deleteRequest("/assetsections", assetSectionId)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
export var editAssetSection = function (data) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, putRequest("/assetSections", data, RequestDataType.FormData)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
